import AhaDrawer from 'javascripts/drawer';
import Turbolinks from 'javascripts/turbolinks';
import Shepherd from 'javascripts/shepherd';
import StoreRegister from 'javascripts/store_register';
import { push } from 'connected-react-router';
import _ from 'lodash';
import {
  isLocalStorageSupported,
  getSessionStorageJSONPreference,
  setSessionStorageJSONPreference,
  appendQueryParams,
} from 'javascripts/utils';
import $ from 'jquery';
import AhaAnalytics from 'javascripts/analytics';
import { PopupPriority, registerModal } from './popup_priority';
import UserPreference from 'components/framework/models/UserPreference';

let pulsingTimeout;

const modal = registerModal('Quick start guide', '#quick_start_guide');

const GettingStarted = {
  didLoadPage: false,
  didCancelTour: false,
  tourInProgress: false,

  createTour(tourContent, stepIndex) {
    if (!tourContent) {
      return;
    }

    const self = this;
    if (this.didLoadPage && this.tour && this.tour.getCurrentStep()) {
      return;
    }

    // Register the tour with the popup priority to block lower priority popups
    PopupPriority.register({
      name: 'Quick start step',
      visible: () => this.tourInProgress,
    });

    this.tourContent = tourContent;
    this.stepIndex = stepIndex;

    if (this.tourContent.completed) {
      this.completedText = this.tourContent.completed.text;
      this.completedUrl = this.tourContent.completed.url;
      this.completedIcon = this.tourContent.completed.icon;
    } else {
      this.completedText = '';
    }

    if (this.tourContent.extra) {
      this.extraCtaUrl = this.tourContent.extra.url;
      this.extraCtaType = this.tourContent.extra.type;
    }

    this.tour = new Shepherd.Tour({
      defaults: {
        classes: 'shepherd-theme-arrows',
      },
    });

    this.tour.analyticsParams = {};

    const result = [];
    Array.from(this.tourContent.steps).forEach((tourData, stepIndex) => {
      let buttons;
      tourData.showCancelLink = true;
      tourData.when = {};

      if (tourData.wait) {
        tourData.beforeShowPromise = function (a) {
          let selector = this.wait;
          if (this.wait === 'product_dropdown') {
            // open and wait for product dropdown
            selector = '.selectro-option.is-selected';
            const $product_dropdown = $('.nav-project-menu-trigger').eq(0);
            $product_dropdown.click();
          }
          if (tourData.beforeShow) {
            // execute the before-show now as it may reveal what we are 'wait'ing for
            self.beforeShowOptions(tourData.beforeShow);
          }
          return new Promise((resolve, reject) => {
            self.waitForElement(selector, resolve);
          });
        };
      } else if (tourData.beforeShow) {
        tourData.when['before-show'] = function () {
          this.options.justHidden = false;
          return self.beforeShowOptions(this.options.beforeShow);
        };
      }

      tourData.when['show'] = function () {
        if (tourData.show) {
          self.showOptions(this.options.show);
        }
        return $('.shepherd-text a[href]').attr('target', '_blank');
      };

      if (tourData.hide) {
        tourData.when['hide'] = function () {
          self.hideOptions(
            this.options.hide,
            this,
            self.didCancelTour || this.options.justHidden
          );
          self.didCancelTour = false;
          return (this.options.justHidden = true);
        };
      }

      tourData.when['remove-opaque'] = function () {
        $('.tour-faded').removeClass('tour-faded');
      };

      tourData.when['make-opaque'] = function () {
        if (tourData.makeOpaque) {
          tourData.makeOpaque.forEach(selector => {
            $(selector).addClass('tour-faded');
          });
        }
      };

      tourData.when['track-step'] = function () {
        var stepTotal = this.tour.steps.length;
        var status;

        if (stepIndex === 0) {
          status = 'started';
        } else if (stepIndex > 0 && stepIndex < stepTotal - 1) {
          status = 'in progress';
        } else if (stepIndex === stepTotal - 1) {
          status = 'completed';
        }

        window.AhaAnalytics.track(
          'Feature-7301392898386535754',
          'User sees tour step',
          {
            'Tour name': GettingStarted.tourContent.type,
            'Current step': stepIndex + 1,
            'Total steps': stepTotal,
            status: status,
            ...this.tour.analyticsParams,
          }
        );
      };

      if (tourData.final) {
        buttons = [];

        if (this.tourContent.extra) {
          buttons.push({
            text: this.tourContent.extra.text,
            action() {
              return self.extraCtaAction();
            },
          });
        }

        if (self.completedText.length > 0) {
          let defaultIcon = "<i class='fa-regular fa-compass'></i>";
          buttons.push({
            text: `${self.completedIcon === false ? '' : defaultIcon} ${
              self.completedText
            }`,
            action() {
              return self.completedAction();
            },
          });
        }

        if (this.tourContent.type === 'manage_users') {
          buttons.unshift({
            text: "<i class='fa-regular fa-users'></i> Add users",
            action() {
              self.tour.next();
              return $('.tour-new-user').click();
            },
          });
        }

        if (this.tourContent.howAhaWorks) {
          buttons.push({
            text: "<i class='fa-regular fa-grid-2-large'></i> Go Back to How Aha! Works",
            kind: 'plain',
            size: 'small',
            action() {
              return self.backToHowAhaWorks();
            },
          });
        }

        if (this.tourContent.quickStartGuideLink) {
          buttons.push({
            text: 'Return to quick start guide',
            kind: 'plain',
            size: 'small',
            action() {
              return self.openQuickStartGuide();
            },
          });
        }

        tourData.buttons = buttons;
      } else {
        let buttons = [];

        if (tourData.draftWithAi) {
          buttons.push(
            {
              text: 'Draft with AI',
              action: self.showDraftWithAiModal,
            },
            {
              text: 'Draft your own',
              action: self.tour.next,
              kind: 'secondary',
            }
          );
        } else {
          buttons.push({
            text: tourData.buttonTitle || 'Next',
            action: self.tour.next,
          });
        }

        if (stepIndex !== 0 && !tourData.noBackButton) {
          buttons.unshift({
            text: 'Back',
            classes: 'shepherd-back-button',
            kind: 'link',
            action: self.tour.back,
          });
        }

        tourData.buttons = buttons;
      }

      result.push(this.tour.addStep(tourData.key, tourData));
    });
    return result;
  },

  active() {
    return this.tourInProgress || this.willStartTour;
  },

  // This only works for actionable tours for now
  JumpToTourStep(tourName, targetStep) {
    let tourActive = GettingStarted.active();

    let currentStep = parseInt(this.tour?.currentStep?.id.replace('step_', ''));

    if (
      tourActive &&
      currentStep &&
      this.tourContent.type === tourName &&
      this.tourContent.actionable &&
      currentStep < targetStep &&
      this.tour.steps.length >= targetStep
    ) {
      if (currentStep + 1 === targetStep) {
        this.tour.next();
      } else {
        this.updateStepPref(this.tour.steps[targetStep - 1]);
        this.tour.show(targetStep - 1);
      }

      return true;
    } else {
      return false;
    }
  },

  startTourDelayed(step, timeout) {
    const self = this;
    this.willStartTour = true;
    return setTimeout(() => self.startTour(step), timeout);
  },

  startTour(step) {
    const self = this;
    if (!this.tour) {
      return;
    }

    if (this.didLoadPage) {
      this.didLoadPage = false;
      return;
    }

    if (step || step === 0) {
      this.tourContent.resumeStep = step;
    }

    this.tour.analyticsParams = {};

    this.didCancelTour = true;
    this.tour.cancel();
    this.didCancelTour = false;

    $('.shepherd-step')
      .removeClass('shepherd-enabled')
      .removeClass('shepherd-open');

    this.tour.off('show');
    this.tour.on('show', stepData => self.updateStepPref(stepData.step));

    this.tour.off('cancel');
    this.tour.on('cancel', () => {
      step = this.tour.getCurrentStep();
      if (step && step.id === 'step_1') {
        this.ajaxTourStep(-1);
      }
      localStorage.removeItem(this.tourContent.type);
      $('.tour-faded').removeClass('tour-faded');
      // if the tour=true persists, it will reopen annoyingly.
      // so lets remove it.
      const url = document.location.href;
      const fullPath = url.split('?')[0];
      const queryParams = url.split('?')[1];
      if (queryParams) {
        window.history.replaceState(
          {},
          '',
          `${fullPath}?${queryParams
            .replace('&tour=true', '')
            .replace('?tour=true', '')}`
        );
      }
    });

    this.tourInProgress = true;
    this.willStartTour = false;

    if (this.stepIndex) {
      this.tour.show(this.stepIndex);
    } else if (
      this.tourContent.resumeStep &&
      this.tourContent.resumeStep < this.tour.steps.length
    ) {
      step = this.tour.getById(`step_${this.tourContent.resumeStep}`);
      if (step.options.needs) {
        if (step.options.needs.match(/^hide/)) {
          this.hideOptions(step.options.needs.replace('hide.', ''));
        } else if (step.options.needs.match(/^show/)) {
          this.showOptions(step.options.needs.replace('show.', ''));
        } else if (step.options.needs.match(/^before_show/)) {
          this.beforeShowOptions(
            step.options.needs.replace('before_show.', '')
          );
        }
      }

      const stepIndex = this.tourContent.resumeStep - 1;
      this.tour.show(stepIndex);
    } else {
      this.ajaxTourStep(1);
      this.tour.start();
    }

    return $('#workspace').attr('data-no-transition-cache', true);
  },

  nextStep(didLoadPage, extraData) {
    if (didLoadPage == null) {
      didLoadPage = false;
    }
    if (extraData == null) {
      extraData = [];
    }
    if (!this.tourInProgress) {
      return;
    }

    if (this.tour) {
      if (extraData.length > 0) {
        extraData.forEach(dataForStep => {
          return _.extend(
            this.tour.steps[dataForStep.step]?.options,
            dataForStep.options
          );
        });
      }

      this.tour.next();
    }

    if (didLoadPage) {
      return (this.didLoadPage = true);
    }
  },

  shallowNextStep() {
    const step = GettingStarted.tour.getCurrentStep();
    if (step) {
      return this.updateStepPref({
        id: `step_${parseInt(step.id.replace('step_', '')) + 1}`,
      });
    }
  },

  closeTour() {
    this.tourInProgress = false;
    return this.tour.cancel();
  },

  completedAction() {
    this.closeTour();

    if (this.completedUrl) {
      if (this.tourContent.howAhaWorks) {
        if (this.completedUrl.indexOf('?') > 0) {
          this.completedUrl += '&how_aha_works=true';
        } else {
          this.completedUrl += '?how_aha_works=true';
        }
      }

      return Turbolinks.visit(this.completedUrl);
    } else {
      return this.tour.next();
    }
  },

  extraCtaAction() {
    if (Shepherd.activeTour) {
      Shepherd.activeTour.cancel();
    }
    if (this.extraCtaUrl) {
      return $.ajax({
        type: 'GET',
        url: this.extraCtaUrl,
      });
    }
  },

  openQuickStartGuide() {
    this.closeTour();
    const $quickStartGuide = $('#quick_start_guide');
    window.AhaAnalytics.track(
      $quickStartGuide.data('tracking-feature'),
      'User clicks to return to guide at end of tour',
      {
        'Tour name': this.tourContent.type,
        'Step type': 'Tour',
      }
    );
    return $quickStartGuide.modal('show');
  },

  backToHowAhaWorks() {
    return Turbolinks.visit('/how_aha_works');
  },

  gotoAddUsers() {
    return Turbolinks.visit('/settings/account/users');
  },

  updateStepPref(step) {
    if (
      step &&
      step.id !== 'step_1' &&
      step.id !== `step_${this.tourContent.resumeStep}`
    ) {
      const currentStepIndex = parseInt(step.id.replace('step_', ''));
      this.tourContent.resumeStep = currentStepIndex;
      if (isLocalStorageSupported()) {
        localStorage.setItem(
          this.tourContent.type,
          JSON.stringify({ step: currentStepIndex, date: Date.now() })
        );
      }
      return this.ajaxTourStep(currentStepIndex);
    }
  },

  ajaxTourStep(step) {
    if (this.tourContent.type === 'design_system_sample_tour') return;

    return $.ajax({
      url: '/getting_started/tour_step',
      data: {
        tour: `getting_started.tour_step.${GettingStarted.tourContent.type}`,
        step,
        product_id: window.currentProjectId,
      },
    });
  },

  hide_dropdowns() {
    return $('.top_nav .dropdown')
      .attr('data-disable-close', 'false')
      .removeClass('open');
  },

  /**
   * Wait for the gantt roadmap to redux store to become available before
   * proceeding
   *
   * @param {((ganttController: typeof window['ganttController']) => void)} callback
   * @returns
   */
  waitForGantt(callback) {
    return new Promise((resolve, reject) => {
      (function waitForGanttStore(timeout = 0) {
        let ganttController = window.ganttController;
        if (ganttController) {
          resolve(ganttController);
        } else if (timeout > 5000) {
          reject(new Error('Gantt roadmap did not render in time for tour'));
        } else {
          setTimeout(() => {
            waitForGanttStore(timeout + 50);
          }, 50);
        }
      })();
    }).then(ganttController => callback(ganttController));
  },

  beforeShowOptions(items) {
    String(items)
      .split(',')
      .forEach(item => {
        switch (item) {
          case 'capture_ideas.open_idea_drawer':
            return $(
              '.ideas-overview-section__activity .idea-stat-table a:first'
            ).trigger('click.aha-drawer-open');
          case 'open_left_sidebar':
            return $('.sidebar-layout--collapsible')
              .addClass('sidebar-layout--expanded')
              .find('.sidebar-layout__toggle-collapsed')
              .click();
          case 'open_right_sidebar':
            return $('.tabbed-details__container').removeClass(
              'tabbed-details__container--collapsed'
            );
          case 'open_add_menu':
            this.hide_dropdowns();
            return $('#top-nav__add')
              .attr('data-disable-close', 'true')
              .addClass('open');
          case 'open_help_menu':
            this.hide_dropdowns();
            return $('.help-dropdown')
              .attr('data-disable-close', 'true')
              .addClass('open');
          case 'open_related_bookmarks':
            $('.bookmark-save-view-control').addClass('open');
            return $('#related_views a').click();
          case 'manage_features.open_feature':
            return $('.card:first').click();
          case 'manage_features.open_parking_lot':
            if (
              $('.project-board-container').hasClass('parking-lot-collapsed')
            ) {
              return $('.show-parking-lot').click();
            }
            break;
          case 'manage_features.close_all_drawers':
            return AhaDrawer.hide();
          case 'manage_features.open_latest_feature_and_initiative_selectro':
            if (!AhaDrawer.isOpen()) {
              return AhaDrawer.showUrl(
                $('.card:first aha-card-two').data('drawer-url')
              );
            }
            return $(
              '.attribute__row[id*=initiative] .SelectroV2__dropdown__trigger-container'
            ).click();

          case 'create_releases.open_view_dropdown':
            return $('.edit_bookmarks_gantt_chart')
              .attr('data-disable-close', 'true')
              .addClass('open');
          case 'create_releases.show_add_features':
            return $('.tools-row').first().addClass('tour-active');
          case 'create_releases_gantt_roadmap.show_add_features':
            this.waitForGantt(ganttController => {
              if (!ganttController) return;
              let release = ganttController.store
                .getState()
                .getIn(['records', 'records'])
                .find(record => record.type === 'Release');
              let expandedRecords = ganttController.store
                .getState()
                .getIn(['records', 'expandedResources']);
              const isExpanded = expandedRecords.has(release.id);
              if (isExpanded) {
                ganttController.actionPatchRecord(
                  release.set('insertMenuOpenedForTour', true)
                );
              } else {
                // Need to expand the release first to make sure
                // the 'insert menu' is visible. Expanding
                // requires loading records, so it may take some
                // time before the 'children' are updated and
                // the record is ready to be patched
                ganttController.dispatch({
                  type: 'SET_IS_EXPANDED',
                  payload: {
                    id: release.id,
                    isExpanded: true,
                    afterCallback: () => {
                      release = ganttController.store
                        .getState()
                        .getIn(['records', 'records'])
                        .find(record => record.id === release.id);

                      window.ganttController?.actionPatchRecord(
                        release.set('insertMenuOpenedForTour', true)
                      );
                    },
                  },
                });
              }
            });
            return;
          case 'create_releases_gantt_roadmap.show_add_dependency':
            this.waitForGantt(ganttController => {
              if (!ganttController) return;
              const record = ganttController
                .getState()
                .getIn(['records', 'records'])
                .find(record =>
                  ['Feature', 'ReleasePhase'].includes(record.type)
                );
              ganttController.actionSetActiveRecord(record);
            });
            return;

          case 'create_releases_gantt_roadmap.open_latest_release':
            if (!AhaDrawer.isOpen()) {
              var releaseBarShown = setInterval(function () {
                if ($('.tourable-release').length) {
                  clearInterval(releaseBarShown);
                  return $('.tourable-release').last().click();
                }
              }, 200);
            }
            break;
          case 'visualize_dependencies.show_manage_dependencies':
            $('aha-menu').find('.fa-gear').click();
            return;

          case 'build_roadmaps.open_releases_menu':
            return $('#page-nav #filter_releases button').click();

          case 'build_roadmaps.open_customize_releases_menu':
            return $('.tour-customize-releases').each((i, elem) => {
              elem.disableClose = true;
              elem.show();
            });

          case 'strategy_tours.show_strategy_nav':
            return $('#nav-strategy-dropdown')
              .attr('data-disable-close', 'true')
              .addClass('open');
          case 'strategy_tours.hide_strategy_nav':
            return $('#nav-strategy-dropdown')
              .attr('data-disable-close', 'false')
              .removeClass('open');

          case 'add_strategy_roadmap.show_add_initiatives':
            return $('.tools-row').first().addClass('tour-active');
          case 'add_strategy_roadmap.open_view_menu':
            return $('#gantt-chart-view-form .popdown__menu')
              .attr('data-disable-close', 'true')
              .trigger('popdown:open');

          case 'build_reports_hierarchy.show_navigation_builder':
            return $('.select-data-btn').click();

          case 'capture_ideas.close_idea_drawer':
            return AhaDrawer.hide();
          case 'capture_ideas.open_promote_menu':
            return $('.tour-promote-to')
              .attr('data-disable-close', '')
              .trigger('show');

          case 'plan_calendar.open_save_menu':
            return $('.save-view-btn').addClass('active');

          case 'plan_calendar.show_add_buttons':
            return $('#calendar-report-calendar .fa-circle-plus').css({
              opacity: '1',
              color: '#666',
            });

          case 'add_persona.open_drawer':
            var url = $('.persona-wrapper .persona-header').data('drawer-url');

            return AhaDrawer.showUrl(url);

          case 'add_persona.close_drawer':
            return AhaDrawer.hide();

          case 'manage_users.add_advance_user':
            return $('#modal-window')
              .find('.close, .btn-primary')
              .addClass('tour-advance-on-click');
          case 'manage_users.advance_on_add_user':
            return $('.tour-new-user').addClass('tour-advance-on-click');

          case 'product_users.add_advance_user':
            return $('#modal-window')
              .find('.close, .btn-primary')
              .addClass('tour-advance-on-click');

          case 'starter_roadmap.show_new_palette':
            $(
              '.roadmap-builder-palette .nav .tour-existing.active'
            ).removeClass('active');
            $('.tour-new').addClass('active');
            $(
              '.roadmap-builder-palette .tab-content .tour-existing-tab.active'
            ).removeClass('active');
            return $('.tour-new-tab').addClass('active');
          case 'starter_roadmap.open_drawer':
            return $(
              '.roadmap-builder-row .release .roadmap-element-container-bar:first'
            ).click();
          case 'starter_roadmap.show_existing':
            $('.roadmap-builder-palette .nav .tour-new.active').removeClass(
              'active'
            );
            $('.tour-existing').addClass('active');
            $(
              '.roadmap-builder-palette .tab-content .tour-new-tab.active'
            ).removeClass('active');
            return $('.tour-existing-tab').addClass('active');
          case 'starter_roadmap.open_drawer_for_feature_a':
            $(
              '.feature.roadmap-element-bar:contains(Click to add feature 1 here)'
            ).click();
            return;
          case 'starter_roadmap.open_view_dropdown':
            return $('.tour-view-dropdown')
              .attr('data-disable-close', 'true')
              .addClass('open');
          case 'starter_roadmap.show_in_menu':
            $('#nav-reports-dropdown').addClass('open');
            break;

          case 'starter_roadmap.show_roadmaps_dropdown':
            return $('#nav-reports-dropdown')
              .attr('data-disable-close', 'true')
              .addClass('open');

          case 'home_portfolio.open_project_menu':
            return $('#product-select-menu').click();

          case 'open_more_menu':
            return $('.page-nav .report-popdown-menu')
              .attr('data-disable-close', 'true')
              .trigger('popdown:open');

          case 'open_views_menu':
            return $('.page-nav .bookmark-dropdown-menu')
              .attr('data-disable-close', 'true')
              .trigger('popdown:open');

          case 'user_story_maps.show_add_release':
            return $('.user-story-map__row__create-release')
              .first()
              .addClass('tour-show');

          case 'feedback_campaigns.open_conversation':
            return document
              .querySelector(
                'button[data-tab-key=feedback_campaigns_conversation]'
              )
              .click();

          case 'feedback_campaigns.open_customization':
            return document
              .querySelector(
                'button[data-tab-key=feedback_campaigns_customization]'
              )
              .click();

          case 'plan_program_increment.open_feature':
            document
              .querySelector(
                'button.flush-tabs__button[data-tab-key="related"]'
              )
              .click();
            return AhaDrawer.showUrl('/develop/features/RED-4');

          case 'develop.open_import_menu':
            return this.waitForElement(
              '[class*=sourceTypeSelector] button.popdown__trigger',
              () => {
                document
                  .querySelector(
                    '[class*=sourceTypeSelector] button.popdown__trigger'
                  )
                  .click();
              }
            );

          case 'now_next_later.open_group_by':
            return this.waitForElement(
              '.now-next-later__group-by-trigger',
              () => {
                document
                  .querySelector('.now-next-later__group-by-trigger')
                  .click();
              }
            );

          case 'knowledge.focus_note':
            return this.waitForElement('.aha-editor-body', () => {
              $('.aha-editor-body').click();
            });

          case 'knowledge.show_note_toolbar':
            return this.waitForElement('.aha-editor-field__wrapper', () => {
              $('.aha-editor-field__wrapper .aha-editor-field').addClass(
                'aha-editor-field-focused'
              );
            });

          case 'knowledge.hide_note_toolbar':
            return this.waitForElement('.aha-editor-field__wrapper', () => {
              $('.aha-editor-field__wrapper .aha-editor-field').removeClass(
                'aha-editor-field-focused'
              );
            });

          case 'knowledge.open_share_web_dropdown':
            return this.waitForElement('.share-page-panel__button', () => {
              document.querySelector('.share-page-panel__button').click();

              document.querySelector('#share-panel-web').click();
            });

          case 'knowledge.open_add_dropdown':
            return this.waitForElement('.add-note-popdown', () => {
              document
                .querySelector('.add-note-popdown')
                .dispatchEvent(new Event('aha-menu:open'));
            });

          case 'workflow_board.expand_sidebar': // same as open_left_sidebar above, but wrapped in waitForElement
            return this.waitForElement('.sidebar-layout__sidebar', () => {
              $('.sidebar-layout--collapsible')
                .addClass('sidebar-layout--expanded')
                .find('.sidebar-layout__toggle-collapsed')
                .click();
            });

          case 'workflow_board.open_group_by_dropdown':
            return this.waitForElement('#develop-board-filter-row', () => {
              document
                .querySelector('#develop-board-filter-row i.fa-layer-group')
                .click();
            });
          case 'develop_timeline.add_features': {
            document
              ?.querySelector('.ganttChartApp .insertRecord:first-of-type')
              ?.dispatchEvent(new MouseEvent('mouseover', { bubbles: true }));
            break;
          }
          case 'develop_timeline.manage_dependencies': {
            document
              ?.querySelector('aha-roadmap-bar:first-of-type')
              ?.dispatchEvent(new MouseEvent('mouseover', { bubbles: true }));
            break;
          }
        }
      });
  },

  showOptions(item) {
    switch (item) {
      case 'attributes.estimate_fields':
        $('.attribute__toggle-empty-attributes').one('click', () => {
          GettingStarted.tour.cancel();
        });
        $(window).one('aha-drawer.hide', () => {
          GettingStarted.tour.cancel();
        });
        return $('.shepherd-cancel-link').attr(
          'data-skip-drawer-close',
          'true'
        );
    }
  },

  hideOptions(item, step, tourCancelled) {
    if (tourCancelled == null) {
      tourCancelled = false;
    }
    $('.tour-advance-on-click')
      .removeClass('tour-advance-on-click')
      .removeAttr('data-delay');
    $('.tour-shallow-advance-on-click').removeClass(
      'tour-shallow-advance-on-click'
    );

    switch (item) {
      case 'close_left_sidebar':
        return $('.sidebar-layout--collapsible').removeClass(
          'sidebar-layout--expanded'
        );
      case 'close_right_sidebar':
        return $('.tabbed-details__container').addClass(
          'tabbed-details__container--collapsed'
        );
      case 'close_add_menu':
        return $('#top-nav__add')
          .removeAttr('data-disable-close')
          .removeClass('open');
      case 'close_help_menu':
        return $('.help-dropdown')
          .removeAttr('data-disable-close')
          .removeClass('open');
      case 'close_related_bookmarks':
        return $('.bookmark-save-view-control').removeClass('open');
      case 'manage_features.close_release_actions_menu':
        return $('.release:first .more-menu')
          .trigger('popdown:close')
          .removeAttr('data-disable-close');
      case 'manage_features.open_drawer':
        if (!tourCancelled) {
          return $('.card:first').click();
        }
        break;
      case 'create_releases.open_release':
        if ($('.chart-group.release-phase').length === 0) {
          if (!tourCancelled) {
            return $('.toggle-control:first').click();
          }
        }
        break;
      case 'create_releases.close_view_dropdown':
        return $('.edit_bookmarks_gantt_chart')
          .removeAttr('data-disable-close')
          .removeClass('open');
      case 'create_releases.hide_add_features':
        return $('.tour-active').removeClass('tour-active');

      case 'create_releases_gantt_roadmap.hide_add_features':
        this.waitForGantt(ganttController => {
          if (!ganttController) return;
          const release = ganttController
            .getState()
            .getIn(['records', 'records'])
            .find(record => record.insertMenuOpenedForTour);
          if (release) {
            ganttController.actionPatchRecord(
              release.set('insertMenuOpenedForTour', false)
            );
          }
        });
        return;

      case 'create_releases_gantt_roadmap.go_to_features':
        this.showTourLinkTransition();
        window.location.href =
          window.location.pathname.replace(
            /\/bookmarks\/gantt_roadmaps\/[\S]+/,
            '/feature_cards'
          ) + window.location.search;
        break;

      case 'plan_calendar.close_save_menu':
        return $('.save-view-btn').removeClass('active');

      case 'plan_calendar.hide_add_buttons':
        return $('#calendar-report-calendar .fa-circle-plus').css({
          opacity: '',
          color: '',
        });

      case 'build_roadmaps.close_releases_menu':
        return $('#selectro-modal').remove();
      case 'build_roadmaps.close_customize_releases_menu':
        return $('.tour-customize-releases').each((i, elem) => {
          elem.disableClose = false;
          elem.hide();
        });

      case 'add_strategy_goals.open_goal_drawer':
        if (!tourCancelled) {
          return $('.strategic-imperative:first').trigger(
            'click.aha-drawer-open'
          );
        }
        break;
      case 'add_strategy_goals.close_goal_drawer':
        if (!tourCancelled) {
          return AhaDrawer.hide();
        }
        break;

      case 'strategy_tours.hide_strategy_nav':
        return $('#nav-strategy-dropdown')
          .attr('data-disable-close', 'false')
          .removeClass('open');

      case 'add_strategy_initiatives.open_initiative_drawer':
        if (!tourCancelled) {
          return $('.scorecard.initiative:first').trigger(
            'click.aha-drawer-open'
          );
        }
        break;
      case 'add_strategy_initiatives.close_initiative_drawer':
        if (!tourCancelled) {
          return AhaDrawer.hide();
        }
        break;

      case 'add_strategy_initiatives_at.go_to_releases':
        this.showTourLinkTransition();
        window.location.href =
          window.location.pathname.replace(
            /\/initiatives/,
            '/bookmarks/gantt_roadmaps/new'
          ) + window.location.search;
        break;

      case 'add_strategy_roadmap.show_add_initiatives':
        return $('.tour-active').removeClass('tour-active');
      case 'add_strategy_roadmap.close_view_menu':
        return $('#gantt-chart-view-form .popdown__menu')
          .removeAttr('data-disable-close')
          .removeClass('active disable');

      case 'build_reports_hierarchy.show_navigation_builder':
        if (!tourCancelled) {
          return $('.select-data-btn').click();
        }
        break;
      case 'build_reports_hierarchy.close_navigation_builder':
        return $('.modal').modal('hide');

      case 'manage_users.open_user_modal':
        if (!tourCancelled) {
          return $('.tour-new-user').click();
        }
        break;
      case 'product_users.open_user_modal':
        if (!tourCancelled) {
          return $('#add-project-user-button').click();
        }
        break;
      case 'manage_users.close_add_user_modal':
        if (!tourCancelled) {
          return $('#modal-window').modal('hide');
        }
        break;
      case 'product_users.close_add_user_modal':
        if (!tourCancelled) {
          return $('#modal-window').modal('hide');
        }
        break;

      case 'capture_ideas.close_promote_menu':
        return $('.tour-promote-to')
          .removeAttr('disable-close')
          .trigger('hide');

      case 'capture_ideas.open_idea_drawer':
        return $('.idea-stat-table a:first').trigger('click.aha-drawer-open');
      case 'starter_roadmap.open_feature_drawer':
        if (step.options.featureId) {
          return AhaDrawer.showUrl(`/features/${step.options.featureId}`);
        }
        break;
      case 'capture_ideas.close_idea_drawer':
        return AhaDrawer.hide();
      case 'starter_roadmap.close_drawer':
        return $('.drawer').removeClass('in');
      case 'starter_roadmap.close_existing':
        $('.roadmap-builder-palette .nav .tour-existing.active').removeClass(
          'active'
        );
        $('.tour-new').addClass('active');
        $(
          '.roadmap-builder-palette .tab-content .tour-existing-tab.active'
        ).removeClass('active');
        return $('.tour-new-tab').addClass('active');
      case 'starter_roadmap.hide_nav_menu':
        $('#nav-reports-dropdown').removeClass('open');
        break;
      case 'starter_roadmap.close_feature_drawer':
        if (!tourCancelled) {
          return AhaDrawer.hide();
        }
        break;
      case 'starter_roadmap.close_view_dropdown':
        return $('.tour-view-dropdown')
          .removeAttr('data-disable-close')
          .removeClass('open');
      case 'starter_roadmap.remove_roadmaps_dropdown':
        return $('#nav-reports-dropdown')
          .removeAttr('data-disable-close')
          .removeClass('open');

      case 'home_portfolio.close_project_menu':
        return $('#selectro-modal').remove();

      case 'share_notebooks.open_slide':
        return AhaDrawer.showUrl(
          $(
            '.notebook-slide.notebook-slide-draggable:first .notebook-slide-content'
          ).attr('data-drawer-url')
        );

      case 'close_more_menu':
        return $('.page-nav .report-popdown-menu')
          .removeAttr('data-disable-close')
          .removeClass('active disable');

      case 'close_views_menu':
        return $('.page-nav .bookmark-dropdown-menu')
          .removeAttr('data-disable-close')
          .removeClass('active disable');

      case 'reports_dashboard.goto_saved':
        return StoreRegister.get('reportDashboard')?.dispatch(
          push('/reports/saved/all')
        );

      case 'reports_dashboard.goto_examples':
        return StoreRegister.get('reportDashboard')?.dispatch(
          push('/reports/example/all')
        );

      case 'user_story_maps.hide_add_release':
        return $('.user-story-map__row__create-release.tour-show').removeClass(
          'tour-show'
        );

      case 'idea_organizations.open_organization_drawer':
        if (!tourCancelled) {
          return $(
            'table.organizations-table a[data-drawer-url*="ideas/idea_organizations"]:first'
          ).trigger('click.aha-drawer-open');
        }
        break;

      case 'segments.open_segment_drawer':
        if (!tourCancelled) {
          return $(
            'table.segments-table a[data-drawer-url*="ideas/segments"]:first'
          ).trigger('click.aha-drawer-open');
        }
        break;
      case 'develop_timeline.add_features': {
        if (!tourCancelled) {
          document
            ?.querySelector('.ganttChartApp .insertRecord:first-of-type')
            ?.dispatchEvent(new MouseEvent('mouseout', { bubbles: true }));
        }
        break;
      }
      case 'develop_timeline.manage_dependencies': {
        if (!tourCancelled) {
          document
            ?.querySelector('aha-roadmap-bar:first-of-type')
            ?.dispatchEvent(new MouseEvent('mouseout', { bubbles: true }));
        }
        break;
      }
    }
  },

  gotoPath(path) {
    this.didLoadPage = true;
    return Turbolinks.visit(appendQueryParams(path, { tour: 'true' }));
  },

  waitForElement(selector, resolve) {
    const el = $(selector);
    if (el.length > 0) {
      // console.log(`Finished for ${selector}`);
      if (el.parents('#modal-window').length > 0) {
        setTimeout(resolve, 450);
      } else {
        window.requestAnimationFrame(resolve);
      }
    } else {
      setTimeout(() => this.waitForElement(selector, resolve), 50);
    }
  },

  showPulsingDot() {
    // don't show pulsing dot until the QSG is closed
    if ($('.quick-start-guide.in').length) {
      setTimeout(GettingStarted.showPulsingDot, 2000);
    } else {
      // show after a few seconds
      setTimeout(() => $('.pulsing-dot__container').show(), 5000);
    }
  },

  initPulsingDot(timeout, demoProductId) {
    // Expand the demo product line in the dropdown
    const collapsible =
      getSessionStorageJSONPreference('selectro-collapsible') || {};
    if (!collapsible['nav-projects-menu']) {
      collapsible['nav-projects-menu'] = {};
    }

    collapsible['nav-projects-menu'][demoProductId] = true;
    setSessionStorageJSONPreference('selectro-collapsible', collapsible);

    if (pulsingTimeout) {
      clearTimeout(pulsingTimeout);
    }

    pulsingTimeout = setTimeout(GettingStarted.showPulsingDot, timeout);
  },

  showContactModalDot() {
    if ($('.quick-start-guide.in').length) {
      // don't show pulsing dot until the QSG is closed
      setTimeout(GettingStarted.showContactModalDot, 2000);
    } else {
      // show after a few seconds
      setTimeout(() => $('.pulsing-dot__container--contact-modal').show(), 0);
    }
  },

  initContactModalDot() {
    setTimeout(GettingStarted.showContactModalDot, 1000);
  },

  showTourLinkTransition() {
    AhaDrawer.hide();

    // give elements a chance to remove shepherd classes first, otherwise classes don't apply properly
    setTimeout(() => {
      $('#workspace').addClass('tour-faded');
      $('.top-nav').addClass('tour-faded');
      $('#page-nav').addClass('tour-faded');
    }, 50);
  },

  showDraftWithAiModal() {
    let draftWithAiParams = GettingStarted.tour.currentStep.options.draftWithAi;

    if (draftWithAiParams) {
      GettingStarted.tour.hide();

      return $.ajax({
        type: 'GET',
        url: '/demo_data_ai/draft_with_ai_modal',
        data: {
          ...draftWithAiParams,
          ...{ tour_name: GettingStarted.tourContent.type },
        },
      });
    }
  },
};

function markQuickStartAsCompleted(item) {
  $('#quick_start_guide').trigger(
    'aha.quick-start.tour-complete',
    item.data('quick-start-tour')
  );
}

$(() => {
  $(document).on('click', '.show_tour', event => {
    GettingStarted.startTour();
    return false;
  });

  $(document).on('click', '.tour-advance-on-click', function () {
    const delay = parseInt($(this).attr('data-delay'));
    const didLoadPage = $(this).attr('data-no-page-change') !== 'true';
    if (delay) {
      return setTimeout(() => GettingStarted.nextStep(didLoadPage), delay);
    } else {
      return GettingStarted.nextStep(didLoadPage);
    }
  });

  $(document).on('click', '.tour-shallow-advance-on-click', () =>
    GettingStarted.shallowNextStep()
  );

  $(document).on('mouseup', '.shepherd-step .shepherd-cancel-link', event => {
    GettingStarted.didCancelTour = true;
    return (GettingStarted.tourInProgress = false);
  });

  $(document).on('click', '.close-quick-start', function (event) {
    const $gettingStartedBanner = $(this).parents('.getting-started-header');
    $gettingStartedBanner.addClass('getting-started-header--hidden');
    $gettingStartedBanner.slideUp(150, '', e => {
      $gettingStartedBanner.remove();
    });
    $('.with-top-banner').removeClass('with-top-banner');
    UserPreference.deleteUserPreference(
      'welcome_center.show_welcome_center_banner'
    );
    return false;
  });

  $(document).on(
    'click',
    '.getting-started-header__quick-start:not(.getting-started-header__quick-start--return-workspace)',
    function (e) {
      if ($(e.target).attr('no-modal') === 'true') return;

      modal.toggle();
    }
  );

  $(document).on(
    'click',
    `
      .quick-start-guide__learn-more__video,
      .quick-start-guide__learn-more__talk,
      .quick-start-guide .modal-header .btn,
      .quick-start-guide__learn-more__demo,
      .quick-start-guide .ask-for-help a,
      [data-quick-start-tour="product"] a,
      .quick-start-guide__invite-users,
      .quick-start-guide__hide-on-click a
    `,
    function (event) {
      modal.hide();
      if (GettingStarted.tour) GettingStarted.closeTour();
    }
  );

  $(document).on(
    'click',
    '.quick-start-guide__task a[data-click-preference]',
    function (e) {
      UserPreference.setUserPreference(
        $(this).attr('data-click-preference'),
        'true'
      );

      markQuickStartAsCompleted(
        $(this).parents('.quick-start-guide__task').first()
      );
    }
  );

  $(document).on(
    'click',
    '.quick-start-guide a[data-close-qsg-on-click]',
    function (e) {
      $('#quick_start_guide').modal('hide');
    }
  );

  $(document).on(
    'click',
    '.quick-start-guide__welcome-message__next',
    function (e) {
      e.preventDefault();
      $('.quick-start-guide__welcome-message').hide();
      $('.quick-start-guide__content').show();
      $('.ask-for-help').removeClass('hide');
    }
  );

  $(document).on(
    'click',
    '[data-tracking-element-id="Feature-6691411060349432360"], [data-tracking-element-id="Feature-6976297521602439401"], [data-tracking-element-id="Feature-7007908098651923411"]',
    function (event) {
      const eventName = $(this).attr('data-tracking-event-name');
      const eventData = {
        'Workspace type': window.currentWorkspaceTypeName,
        Role: window.currentUserRole,
      };

      const properties = $(this).data('trackingProperties');
      if (properties) {
        Object.assign(eventData, properties);
      }

      AhaAnalytics.track(
        $(this).attr('data-tracking-element-id'),
        eventName,
        eventData
      );
    }
  );
});

export default GettingStarted;
